<script lang="ts" setup>
import { useDeviceType } from 'theme/composables/useDeviceType';

const { isDesktop } = useDeviceType();
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.content">
      <div v-if="isDesktop">
        <img src="./hero_pc.svg" alt="フィデューシャリーデューティー宣言" />
        <h1 :class="$style.title">
          人生100年時代、<br />
          お金の不安のない明るい未来を想像できる人は<br />
          どれくらいいるでしょうか？
        </h1>
      </div>
      <div v-else>
        <img src="./hero_sp.svg" alt="フィデューシャリーデューティー宣言" />
        <h1 :class="$style.title">
          人生100年時代、<br />
          お金の不安のない明るい未来を<br />
          想像できる人は<br />
          どれくらいいるでしょうか？
        </h1>
      </div>
      <div :class="$style.text">
        <p :class="$style.paragraph">
          お金に関して不安なこと、知りたいこと、解決したいこと、もっと良くしたいことがある時、「自分で解決できない」「相談相手がいない」といった”アドバイス難民”が日本には多くいらっしゃいます。
        </p>
        <p :class="$style.paragraph">
          そのような中で、「オカネコ」はユーザーの皆さま（お客様）にとって利便性高く、さらにはお客様本位でコストパフォーマンスの良いアドバイスをご提供することで、みなさまがより豊かな人生を歩んでいけるようにサポートしたいと考えています。
        </p>
        <p :class="$style.paragraph">
          「オカネコ」では当社社員が「オンラインアドバイザー」として、有価証券等や保険商品のアドバイスを行っております。
        </p>
        <p :class="$style.paragraph">
          「オカネコ」は、ユーザーの皆さまへ、最適、最良のサービスをご提供し、お金のプロとして信頼いただけるサービスとなれることを目指して、お客様本位の運営を追求していくことを宣言します。
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 16px;
  margin-bottom: 88px;
  padding: 0 16px;
}

.content {
  max-width: 688px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.title {
  line-height: 165%;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-top: 56px;

  @include desktop-only {
    font-size: 28px;
    margin-top: 72px;
  }
}

.text {
  margin-top: 20px;
}

.paragraph {
  font-size: 14px;

  &:nth-child(n + 2) {
    margin-top: 20px;
  }
}
</style>
